import { useEffect } from 'react'

export function useWindowLeave(fn) {
  useEffect(() => {
    document.body.addEventListener('mouseleave', fn)
    return () => {
      document.body.removeEventListener('mouseleave', fn)
    }
  }, [fn])
}
